import { Link } from "react-router-dom";
import { Icon } from "../components/Icons.jsx";
import Seo from "../components/Seo.jsx";

export default function About() {
  return (
    <>
      <Seo
        title="About Vigyan Bhairava Tantra · Simple Meditation World"
        description="Vigyan Bhairava Tantra: an ancient meditation text describing 112 doorways into awareness. We translate them into simple modern practices."
        path="/about"
      />
      <section className="section-night subtle" id="about" style={{ paddingTop: 80 }}>
        <div className="container">
          <div className="about-wrap">
            <div className="about-manuscript">
              <div className="verse-lbl">From the Vigyan Bhairava Tantra</div>
              <blockquote>
                "By what means can one acquire and be filled with that form of God? In what way is the Supreme Goddess the entrance?"
              </blockquote>
              <cite>— Opening dialogue, source verse 23</cite>
            </div>
            <div className="about-content">
              <span className="eyebrow" style={{ color: "var(--gold)", display: "block", marginBottom: 18 }}>The source</span>
              <h1>What is <em>Vigyan Bhairava Tantra?</em></h1>
              <p>Vigyan Bhairava Tantra is an ancient meditation text presented as a dialogue between Shiva and the Goddess. It describes 112 ways to enter meditation through ordinary human experience: breath, sound, body, emotion, space, darkness, devotion, sensation, thought, and awareness.</p>
              <p>Each technique is short. Often only a single line. Each one is a doorway you can try, today, in your real life.</p>

              <div id="how" style={{ marginTop: 26, display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 }}>
                <div style={{ padding: "18px 20px", background: "rgba(229, 193, 106, 0.05)", border: "1px solid rgba(229, 193, 106, 0.16)", borderRadius: 10 }}>
                  <div style={{ fontFamily: "var(--mono)", fontSize: 10, letterSpacing: "0.2em", color: "var(--gold)", textTransform: "uppercase", marginBottom: 8 }}>What this site does</div>
                  <p style={{ fontSize: 13.5, lineHeight: 1.55, color: "rgba(248, 241, 231, 0.78)", margin: 0 }}>
                    We do not replace the original text. We translate each doorway into simple practice language for modern seekers.
                  </p>
                </div>
                <div style={{ padding: "18px 20px", background: "rgba(229, 193, 106, 0.05)", border: "1px solid rgba(229, 193, 106, 0.16)", borderRadius: 10 }}>
                  <div style={{ fontFamily: "var(--mono)", fontSize: 10, letterSpacing: "0.2em", color: "var(--gold)", textTransform: "uppercase", marginBottom: 8 }}>How to use it</div>
                  <p style={{ fontSize: 13.5, lineHeight: 1.55, color: "rgba(248, 241, 231, 0.78)", margin: 0 }}>
                    Read the essence. Try the practice. Observe your experience. Continue only with what feels natural.
                  </p>
                </div>
              </div>

              <div id="mistakes" style={{ marginTop: 28, padding: "22px 24px", background: "rgba(229, 193, 106, 0.05)", border: "1px solid rgba(229, 193, 106, 0.16)", borderRadius: 10 }}>
                <div style={{ fontFamily: "var(--mono)", fontSize: 10, letterSpacing: "0.2em", color: "var(--gold)", textTransform: "uppercase", marginBottom: 12 }}>Common Mistakes</div>
                <ul style={{ color: "rgba(248,241,231,0.78)", fontSize: 14, lineHeight: 1.65, margin: 0, paddingLeft: 18 }}>
                  <li>Trying many techniques at once. Stay with one for a week.</li>
                  <li>Treating meditation as performance. There is nothing to achieve.</li>
                  <li>Forcing the breath, the emotion, or the altered state. The doorway opens when you stop pushing.</li>
                  <li>Skipping the reflection. The journal entry, even one line, is part of the practice.</li>
                </ul>
              </div>

              <div className="note">
                <b>A respectful note ·</b> We present these techniques as a map of meditation methods, not as a religious teaching. No belief is required. The instrument is your direct experience.
              </div>

              <div style={{ marginTop: 36, display: "flex", gap: 10, flexWrap: "wrap" }}>
                <Link className="btn btn-primary" to="/find-my-doorway">Find My Doorway {Icon.arrowSm()}</Link>
                <Link className="btn btn-secondary" to="/techniques" style={{ background: "transparent", color: "var(--ivory)", border: "1px solid rgba(229,193,106,0.4)" }}>
                  Explore All 112
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
